import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Table,
  Tag,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  TableItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import {
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
import SelectDepartamentosItem from "../../../../Components/SelectDepartamentosItem";
import SelectRelojesChecadoresItem from "../../../../Components/SelectRelojesChecadoresItem";
import reporteRegistroEmpleadosPdf from "../../../../Pdf/reporteRegistroEmpleadosPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

const getEstadoTexto = (estadoNum) => (estadoNum === 1 ? "Activo" : "Inactivo");

const BIOMETRIA_STATUS = {
  completo: { texto: "Completo", color: "green" },
  parcial: { texto: "Parcial", color: "orange" },
  sin_datos: { texto: "Sin Datos", color: "default" },
};

// Mismos 3 estados, en hex para las celdas de Excel (paleta semaforo
// clasica: verde/amarillo/rojo), consistente con BIOMETRIA_STATUS de arriba.
const BIOMETRIA_COLOR_EXCEL = {
  completo: { bg: "C6EFCE", font: "000000" },
  parcial: { bg: "FFEB9C", font: "000000" },
  sin_datos: { bg: "FFC7CE", font: "000000" },
};

const columnasRostros = [
  {
    title: "Reloj Checador",
    dataIndex: "relojChecadorNombre",
    key: "relojChecadorNombre",
    ellipsis: true,
  },
  {
    title: "No. Plantilla",
    dataIndex: "no",
    key: "no",
    ellipsis: true,
    render: (no, record) => `${no ?? "N/A"}${record.legacy ? " (legacy)" : ""}`,
  },
  {
    title: "Capturado",
    dataIndex: "capturadoAt",
    key: "capturadoAt",
    ellipsis: true,
    render: (fecha) => (fecha ? moment(fecha).format("DD/MM/YYYY HH:mm") : "N/A"),
  },
];

const columnasHuellas = [
  {
    title: "Reloj Checador",
    dataIndex: "relojChecadorNombre",
    key: "relojChecadorNombre",
    ellipsis: true,
  },
  {
    title: "Dedo",
    dataIndex: "fid",
    key: "fid",
    ellipsis: true,
    render: (fid) => (fid ?? "N/A"),
  },
  {
    title: "Capturado",
    dataIndex: "capturadoAt",
    key: "capturadoAt",
    ellipsis: true,
    render: (fecha) => (fecha ? moment(fecha).format("DD/MM/YYYY HH:mm") : "N/A"),
  },
];

const columnasRegistros = [
  {
    title: "Reloj Checador",
    dataIndex: "relojChecadorNombre",
    key: "relojChecadorNombre",
    ellipsis: true,
  },
  {
    title: "Ubicacion",
    dataIndex: "ubicacion",
    key: "ubicacion",
    ellipsis: true,
  },
  {
    title: "Usuario/PIN",
    dataIndex: "usuarioRelojChecador",
    key: "usuarioRelojChecador",
    ellipsis: true,
  },
  {
    title: "Fecha Alta",
    dataIndex: "fechaAlta",
    key: "fechaAlta",
    ellipsis: true,
    render: (fecha) => (fecha ? moment(fecha).format("DD/MM/YYYY") : "N/A"),
  },
  {
    title: "Estado",
    dataIndex: "estadoAsignacion",
    key: "estadoAsignacion",
    ellipsis: true,
    render: (estado) => getEstadoTexto(estado),
  },
];

class ReporteRegistroEmpleados extends Component {
  state = {
    loading: false,
    dataReporte: null,
    todosEmpleados: [],
  };

  atras() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.consultarReporteRegistroEmpleados({
      departamentos: [],
      relojesChecadores: [],
      estado: 3,
    });
  }

  consultarReporteRegistroEmpleados(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesRecursosHumanos/reporteRegistroEmpleados",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todosEmpleados: res.data.empleados,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        message.error("Error de conexión: " + err.message);
        this.setState({ loading: false });
      });
  }

  estiloExcel() {
    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "13A8A8" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    // Estilo de celda coloreado segun que tan completo esta el registro
    // biometrico del empleado dueño de la fila (verde/amarillo/rojo).
    const estiloPorStatus = (status) => {
      const paleta = BIOMETRIA_COLOR_EXCEL[status] || BIOMETRIA_COLOR_EXCEL.sin_datos;
      return {
        font: { color: { rgb: paleta.font } },
        fill: { fgColor: { rgb: paleta.bg } },
        alignment: { vertical: "center" },
        border,
      };
    };
    const celda = (value, status) => ({
      v: value === null || value === undefined || value === "" ? "N/A" : value,
      s: estiloPorStatus(status),
    });
    return { headerStyle, estiloPorStatus, celda, border };
  }

  descargarExcel() {
    const { headerStyle, estiloPorStatus, celda } = this.estiloExcel();
    const textoLeyenda = { font: { sz: 9 }, alignment: { vertical: "center" } };
    const tituloLeyenda = { font: { bold: true, sz: 10 } };

    // ── Hoja 1: Resumen por empleado, una linea por empleado coloreada
    //    segun que tan completo esta su registro biometrico ──
    const columnasResumen = [
      "Numero", "Nombre", "Departamento", "Estado",
      "Relojes Asignados", "PIN(s)", "Rostros Capturados", "Huellas Capturadas",
      "Contrasena Reloj", "Estado Biometria", "Ultima Actualizacion Biometria",
    ];

    const filasResumen = this.state.todosEmpleados.map((empleado) => {
      const biometria = empleado.biometria || {};
      const status = biometria.status || "sin_datos";
      const registros = empleado.registros || [];
      const valores = [
        empleado.serieNumero,
        empleado.nombre,
        empleado.departamento,
        getEstadoTexto(empleado.estado),
        registros.map((r) => r.relojChecadorNombre).filter(Boolean).join(", "),
        registros.map((r) => r.usuarioRelojChecador).filter(Boolean).join(", "),
        biometria.rostros?.length || 0,
        biometria.huellas?.length || 0,
        biometria.tieneContrasena ? "Si" : "No",
        (BIOMETRIA_STATUS[status] || BIOMETRIA_STATUS.sin_datos).texto,
        biometria.actualizadoAt ? moment(biometria.actualizadoAt).format("DD/MM/YYYY HH:mm") : "",
      ];
      return valores.map((valor) => celda(valor, status));
    });

    const filasLeyenda = [
      [{ v: "Leyenda - Estado del Registro Biometrico:", s: tituloLeyenda }],
      [{ v: "Completo", s: estiloPorStatus("completo") }, { v: "Rostro y/o huellas capturados, registro biometrico completo", s: textoLeyenda }],
      [{ v: "Parcial", s: estiloPorStatus("parcial") }, { v: "Registro biometrico incompleto", s: textoLeyenda }],
      [{ v: "Sin Datos", s: estiloPorStatus("sin_datos") }, { v: "No se ha capturado ningun dato biometrico", s: textoLeyenda }],
      [],
    ];

    const hojaResumen = XLSXStyle.utils.aoa_to_sheet([
      ...filasLeyenda,
      columnasResumen.map((titulo) => ({ v: titulo, s: headerStyle })),
      ...filasResumen,
    ]);
    hojaResumen["!cols"] = columnasResumen.map((titulo) => ({ wch: Math.max(titulo.length + 2, 14) }));

    // ── Hojas de detalle: registros por reloj, rostros y huellas, cada
    //    fila coloreada igual segun el status biometrico del empleado ──
    const columnasRegistrosExcel = ["Numero", "Nombre", "Departamento", "Reloj Checador", "Ubicacion", "Usuario/PIN", "Fecha Alta", "Estado Asignacion"];
    const columnasRostrosExcel = ["Numero", "Nombre", "Reloj Checador", "No. Plantilla", "Legacy", "Capturado"];
    const columnasHuellasExcel = ["Numero", "Nombre", "Reloj Checador", "Dedo", "Capturado"];

    const filasRegistros = [];
    const filasRostrosExcel = [];
    const filasHuellasExcel = [];

    for (const empleado of this.state.todosEmpleados) {
      const status = empleado.biometria?.status || "sin_datos";
      const registros = empleado.registros && empleado.registros.length > 0 ? empleado.registros : [null];

      registros.forEach((registro) => {
        filasRegistros.push([
          celda(empleado.serieNumero, status),
          celda(empleado.nombre, status),
          celda(empleado.departamento, status),
          celda(registro ? registro.relojChecadorNombre : "Sin registros", status),
          celda(registro?.ubicacion, status),
          celda(registro?.usuarioRelojChecador, status),
          celda(registro?.fechaAlta ? moment(registro.fechaAlta).format("DD/MM/YYYY") : "", status),
          celda(registro ? getEstadoTexto(registro.estadoAsignacion) : "", status),
        ]);
      });

      (empleado.biometria?.rostros || []).forEach((rostro) => {
        filasRostrosExcel.push([
          celda(empleado.serieNumero, status),
          celda(empleado.nombre, status),
          celda(rostro.relojChecadorNombre, status),
          celda(rostro.no, status),
          celda(rostro.legacy ? "Si" : "No", status),
          celda(rostro.capturadoAt ? moment(rostro.capturadoAt).format("DD/MM/YYYY HH:mm") : "", status),
        ]);
      });

      (empleado.biometria?.huellas || []).forEach((huella) => {
        filasHuellasExcel.push([
          celda(empleado.serieNumero, status),
          celda(empleado.nombre, status),
          celda(huella.relojChecadorNombre, status),
          celda(huella.fid, status),
          celda(huella.capturadoAt ? moment(huella.capturadoAt).format("DD/MM/YYYY HH:mm") : "", status),
        ]);
      });
    }

    const construirHoja = (columnas, filas) => {
      const hoja = XLSXStyle.utils.aoa_to_sheet([
        columnas.map((titulo) => ({ v: titulo, s: headerStyle })),
        ...filas,
      ]);
      hoja["!cols"] = columnas.map((titulo) => ({ wch: Math.max(titulo.length + 2, 12) }));
      return hoja;
    };

    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, hojaResumen, "Resumen Biometrico");
    XLSXStyle.utils.book_append_sheet(workbook, construirHoja(columnasRegistrosExcel, filasRegistros), "Registro Reloj");
    XLSXStyle.utils.book_append_sheet(workbook, construirHoja(columnasRostrosExcel, filasRostrosExcel), "Rostros");
    XLSXStyle.utils.book_append_sheet(workbook, construirHoja(columnasHuellasExcel, filasHuellasExcel), "Huellas");
    XLSXStyle.writeFile(workbook, `Registro_Empleados_${moment().format("YYYY-MM-DD")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteRegistroEmpleadosPdf(this.state.dataReporte))
      .download("Registro_Empleados.pdf");
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Numero",
        dataIndex: "serieNumero",
        key: "serieNumero",
        sorter: (a, b) => (a.numero || 0) - (b.numero || 0),
        buscar: "serieNumero",
        ellipsis: true,
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => (a.nombre || "").localeCompare(b.nombre || ""),
        buscar: "nombre",
        ellipsis: true,
      },
      {
        title: "Departamento",
        dataIndex: "departamento",
        key: "departamento",
        sorter: (a, b) => (a.departamento || "").localeCompare(b.departamento || ""),
        buscar: "departamento",
        ellipsis: true,
      },
      {
        title: "Relojes Registrados",
        dataIndex: "registros",
        key: "registros",
        ellipsis: true,
        render: (registros) => (registros ? registros.length : 0),
      },
      {
        title: "Rostros",
        dataIndex: "biometria",
        key: "rostros",
        ellipsis: true,
        render: (biometria) => (biometria?.rostros ? biometria.rostros.length : 0),
      },
      {
        title: "Huellas",
        dataIndex: "biometria",
        key: "huellas",
        ellipsis: true,
        render: (biometria) => (biometria?.huellas ? biometria.huellas.length : 0),
      },
      {
        title: "Biometria",
        dataIndex: "biometria",
        key: "biometriaStatus",
        ellipsis: true,
        render: (biometria) => {
          const info = BIOMETRIA_STATUS[biometria?.status] || BIOMETRIA_STATUS.sin_datos;
          return <Tag color={info.color}>{info.texto}</Tag>;
        },
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => a.estado - b.estado,
        ellipsis: true,
        render: (estado) => getEstadoTexto(estado),
      },
    ];

    return (
      <>
        <Form
          name="reporteRegistroEmpleados"
          onFinish={this.consultarReporteRegistroEmpleados.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            departamentos: [],
            relojesChecadores: [],
            estado: 3,
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Registro de Empleados"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem type="primary" htmlType="submit">
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 10,
                marginBottom: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row gutter={[16, 0]}>
                <Col span={9}>
                  <FormItem label="Departamentos" name="departamentos">
                    <SelectDepartamentosItem
                      mode="multiple"
                      placeholder="Filtrar por Departamento(s)"
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                    />
                  </FormItem>
                </Col>
                <Col span={9}>
                  <FormItem label="Relojes Checadores" name="relojesChecadores">
                    <SelectRelojesChecadoresItem
                      mode="multiple"
                      placeholder="Filtrar por Reloj(es) Checador(es)"
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                    />
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label="Estado" name="estado">
                    <Select placeholder="Filtrar Por Estado">
                      <Option value={3}>Todos</Option>
                      <Option value={1}>Activo</Option>
                      <Option value={2}>Inactivo</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </div>

            <TableItem
              rowKey="empleadoId"
              columns={columns}
              dataSource={this.state.todosEmpleados}
              size="small"
              pagination={false}
              expandable={{
                expandedRowRender: (empleado) => {
                  const biometria = empleado.biometria || {};
                  return (
                    <div style={{ padding: "8px 0" }}>
                      {empleado.registros && empleado.registros.length > 0 && (
                        <>
                          <h4 style={{ marginBottom: 8 }}>Registros por Reloj</h4>
                          <Table
                            rowKey="asignacionId"
                            columns={columnasRegistros}
                            dataSource={empleado.registros}
                            size="small"
                            pagination={false}
                            style={{ marginBottom: 16 }}
                          />
                        </>
                      )}

                      <h4 style={{ marginBottom: 8 }}>
                        Registro Biometrico{" "}
                        <Tag color={(BIOMETRIA_STATUS[biometria.status] || BIOMETRIA_STATUS.sin_datos).color}>
                          {(BIOMETRIA_STATUS[biometria.status] || BIOMETRIA_STATUS.sin_datos).texto}
                        </Tag>
                        {biometria.tieneContrasena && <Tag color="blue">Con Contrasena</Tag>}
                      </h4>

                      <h5 style={{ marginBottom: 4 }}>Rostros ({biometria.rostros?.length || 0})</h5>
                      <Table
                        rowKey={(record, index) => `${record.relojChecadorNombre}-${record.no}-${index}`}
                        columns={columnasRostros}
                        dataSource={biometria.rostros || []}
                        size="small"
                        pagination={false}
                        locale={{ emptyText: "Sin rostros registrados" }}
                        style={{ marginBottom: 16 }}
                      />

                      <h5 style={{ marginBottom: 4 }}>Huellas ({biometria.huellas?.length || 0})</h5>
                      <Table
                        rowKey={(record, index) => `${record.relojChecadorNombre}-${record.fid}-${index}`}
                        columns={columnasHuellas}
                        dataSource={biometria.huellas || []}
                        size="small"
                        pagination={false}
                        locale={{ emptyText: "Sin huellas registradas" }}
                      />
                    </div>
                  );
                },
                rowExpandable: () => true,
              }}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteRegistroEmpleados);
